import type { ComponentProps, ReactNode } from 'react'

import isPropValid from '@emotion/is-prop-valid'
import { StyleSheetManager, ThemeProvider as ThemeProviderBase } from 'styled-components'

export const StyledComponentsProvider = ({ children }: { children: ReactNode }) => (
	<StyleSheetManager
		enableVendorPrefixes
		shouldForwardProp={(prop, target) =>
			typeof target !== 'string' || (isPropValid(prop) && !(target === 'div' && (prop === 'fill' || prop === 'type')))
		}
	>
		{children}
	</StyleSheetManager>
)

export const ThemeProvider = (props: ComponentProps<typeof ThemeProviderBase>) => (
	<StyledComponentsProvider>
		<ThemeProviderBase {...props} />
	</StyledComponentsProvider>
)
